const legales = `CARTERA DE CONSUMO. Mantenimiento Mensual: $0. (*) Para más información consulta en >https://www.bbva.com.ar/personas/productos/cuentas/ahorro.html
"Los depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta $1.500.000. En las operaciones a nombre de dos o más personas, la garantía se prorrateará entre sus titulares. En ningún caso, el total de la garantía por persona y por depósito podrá exceder de $1.500.000, cualquiera sea el número de cuentas y/o depósitos. Ley 24485, Decreto 540/1995 y modificatorios y Com. "A" 2337 y sus modificatorias y complementarias. Se encuentran excluidos los captados a tasas superiores a la de referencia conforme a los límites establecidos por el Banco Central, los adquiridos por endoso y los efectuados por personas vinculadas a la entidad financiera."
Los accionistas de BANCO BBVA ARGENTINA S.A. limitan su responsabilidad a la integración de las acciones suscriptas a la ley 19.550 y ley 25.738. CUIT 30-50000319-3. Av. Córdoba 111, piso 31, CABA - CP 1054.
Cartera comercial.Los accionistas del Banco BBVA Argentina S.A. limitan su responsabilidad a la integración de las acciones suscriptas a la ley 19550 y ley 25738 cuit 30-50000319-3.Av. Córdoba 111 piso 31 CABA-CP 1054.
Openpay Argentina S.A. ofrece solo servicios de pago, y no está autorizada como entidad financiera por el BCRA. Los fondos depositados en sus cuentas de pago no constituyen depósitos en entidades financieras, ni cuentan con las garantías de los depósitos previstas en la legislación sobre depósitos en entidades financieras. Openpay Argentina S.A, Av. Córdoba 111 piso 30 CABA – CP 1054, CUIT 30-71716819-0.
`;
/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleAnalyticsId: null,
  googleGTMId: null,
  modulo: "Caja de ahorro",
  cantPasos: 9,
  pasos: {
    consulta: {
      path: "/",
      component: "views/ConsultaEmprendedores",
      titulo: "Conocé nuestra oferta para emprendedores",
      subtitulo: "Te pedimos algunos datos para crear una propuesta a tu medida"
    },
    ofertaCuenta: {
      path: "/ofertaCuenta",
      component: "views/OfertaEmprendedores",
      propuesta: "Potenciá tu emprendimiento con BBVA",
      descripcion:
        "En 72 horas hábiles, te vamos a llamar para ayudarte a contratar los productos para emprendedores",
      titulo: "Caja de ahorro + tarjeta de débito Visa",
      subtitulo: "Además, accedés a productos ideales para impulsar tu negocio",
      tituloConCuenta: "Abrí posibilidades infinitas con Openpay",
      botonSiguiente: "Abrí tu cuenta en BBVA",
      footerText: legales
    },
    gracias: {
      path: "/gracias",
      pasoAnterior: "sucursal",
      component: "views/Gracias",
      footerText: null
    },
    thank: {
      path: "/graciasEmprendedores",
      component: "views/GraciasEmprendedores",
      pasoSiguiente: "celular",
      titulo: "¡Listo! <br/>Ya estás más cerca de tu tarjeta de crédito"
    }
  }
};

export const premios = [
  {
    label: "Aceptar las principales tarjetas",
    icon: "AR-Openpay-GO-UX-V02.svg"
  },
  {
    label: "Cobrar con QR y otros métodos de pago",
    icon: "digital_payment_device_dollar.svg"
  },
  {
    label: "Seguir tus ventas",
    icon: "computer_front_end.svg"
  }
];

export const beneficios = [
  {
    label:
      "<strong>Elegí el plazo de acreditación</strong> y la comisión a abonar.<br>"
  },
  {
    label:
      "<strong>Realizá cobros desde donde estés </strong>mediante link de pago, código QR o lector de tarjetas.<br>"
  },
  {
    label:
      "<strong>Seguí tus ventas de forma simple</strong> y en tiempo real a través del panel de control de la web.<br>"
  },
  {
    label:
      "<strong>Ofrecé cuotas sin interés y promociones</strong> para clientes BBVA.<br>"
  }
];
